import React, { useEffect } from "react";
import { SplashScreen as RouterSplash } from "expo-router";
import { useAuth } from "@components/auth/useAuth";
import { ThemedView } from "@/components/ThemedView";
import { ThemedText } from "@/components/ThemedText";
import { AnimatedIcon } from "@components/AnimatedIcon";
import { ActivityIndicator, View } from "react-native";

// Keep the splash screen visible while we fetch resources
RouterSplash.preventAutoHideAsync();

// Handles the Router splashscreen - do we need both?
export function SplashScreenController() {
  const { isInitialized } = useAuth();

  console.debug("SplashScreenController", isInitialized);

  useEffect(() => {
    if (isInitialized) {
      try {
        RouterSplash.hide();
      } catch (err) {
        console.warn("[SplashScreenController] hide error:", err);
      }
    }
  }, [isInitialized]);

  return null;
}

export default function Splash() {
  return ( 
    <ThemedView className="flex-1 justify-center items-center px-6">
      <View className="items-center gap-6">
        <AnimatedIcon />
        <View className="items-center gap-2">
          <ThemedText type="subtitle" className="font-bold text-center mt-4">
            Welcome to Memories 24x7
          </ThemedText>
          <ThemedText themeColor="textSecondary" className="text-center">
            Initializing secure session...
          </ThemedText>
        </View>
        <ActivityIndicator size="small" color="#3b82f6" className="mt-2" />
      </View>
    </ThemedView>
  );
}
